export default "__VITE_ASSET__VSskEnjm__"